export const formatCaipChainIdToNumber = (chainId: string) => Number(chainId.replace('eip155:', ''));
